export type FileUploadTranslation = {
  deleteDialog: {
    cancel: string;
    confirm: string;
    content: string;
    title: string;
  };
  isUploading: string;
  title: string;
};

export const fileUploadTranslation: FileUploadTranslation = {
  deleteDialog: {
    cancel: 'Anuluj',
    confirm: 'OK',
    content: 'Potwierdź usunięcie pliku: ',
    title: 'Usuwanie pliku',
  },
  isUploading: 'Trwa przesyłanie...',
  title: 'Przenieś tutaj plik lub kliknij, aby wybrać z komputera',
};
